import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Box,
  Button,
  Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Add, Close } from '@mui/icons-material'

import { DialogsEnum } from '@/enums'
import { useUsersDialog } from '@/views/users/hooks/use-users-dialog.hook'
import { BrandsTableComponent } from './'

export const BrandsFormDialog = () => {
  const { t } = useTranslation()

  const { toggleDialog, dialogs } = useUsersDialog()

  const listDialogs = [DialogsEnum.DIALOG_BRAND, DialogsEnum.DIALOG_BRAND_FORM]

  const handleCloseDialog = () => {
    toggleDialog(false, DialogsEnum.DIALOG_BRAND)
  }

  const addNewBrand = () => {
    toggleDialog(true, DialogsEnum.DIALOG_BRAND_FORM)
  }

  return (
    <Dialog
      open={
        dialogs.findIndex(
          (dialog) =>
            dialog.open &&
            listDialogs.findIndex((id) => id === dialog.id) !== -1,
        ) !== -1
      }
      aria-labelledby="dialog-title"
      fullWidth
      sx={{
        '& .MuiDialog-paperFullWidth': {
          width: '1000px',
          maxWidth: '100%',
        },
      }}
    >
      <DialogTitle id="dialog-title">
        <Box mb={1} display="flex" justifyContent="space-between" width="100%">
          <Typography fontWeight={700} variant="h5" sx={{ mt: 0.5, pl: 1 }}>
            {t('listBrands')}
          </Typography>
          <Box display="flex" alignItems="center">
            <Button
              type="submit"
              variant="contained"
              size="small"
              startIcon={<Add />}
              onClick={() => addNewBrand()}
              sx={{ height: '30px', mr: 2 }}
            >
              {t('labels.add')}
            </Button>
            <IconButton onClick={handleCloseDialog}>
              <Close />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <BrandsTableComponent />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}
